import { createSlice } from '@reduxjs/toolkit';

// Initialize from localStorage
const getInitialLanguage = () => {
  return localStorage.getItem('preferredLanguage') ||
         localStorage.getItem('selectedLanguage') ||
         'nl';
};

const languageSlice = createSlice({
  name: 'language',
  initialState: {
    currentLanguage: getInitialLanguage(),
  },
  reducers: {
    setLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export const selectCurrentLanguage = (state) => state.language.currentLanguage;
export default languageSlice.reducer;
